import { Fragment, useState } from "react";
import { useAuth } from "../../config/authContext";
import classes from "./Auth.module.css";
import { useNavigate } from "react-router-dom";
import { API } from "../../config/api";
import { ApiHelper } from "../../helpers/ApiHelper";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import loginlogo from "../../assets/images/logoMain.svg";
import eye from "../../assets/images/eye.png";
import eyeview from "../../assets/images/view.png";
import sliderImg from "../../assets/images/onboarding-img.png";
import "../../assets/css/responsive.css";
import "../../assets/css/style.css";

const Login = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);
  const [loader, setLoader] = useState(false);
  const [openPopUp, setOpenPopUp] = useState(false);
  const [message, setMessage] = useState("");
  const [togglePassword, setTogglePassword] = useState(true);

  const loginHandler = async () => {
    const formData = {
      email: email,
      password: password,
    };
    await ApiHelper.post(API.login, formData).then((resData) => {
      console.log(resData);
      if (resData?.data?.success === true) {
        login();
        localStorage.setItem("UserData", JSON.stringify(resData.data.user));
        localStorage.setItem("UserAccess", JSON.stringify(resData.data));
        localStorage.setItem("isOnboarding", true);
        navigate("/dashboard/candidates");
      } else {
        toast("Please enter valid credentials", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        // alert('Please enter valid credentials')
      }
    });
  };

  function recrutingNav() {
    const link = document.createElement("a");
    link.href = "https://app.avenu.ai/";
    link.download = "avenu";
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  return (
    <Fragment>
      <header className="loginHeader wraper">
        <div className="container-fluid">
          <div className="wraper d-flex justify-content-between align-items-center">
            <div className="login_logo">
              <img src={loginlogo} alt="test" className="logo_Img" />
            </div>
            <div className="login_link">
              <a href="#">Need help?</a>
            </div>
          </div>
        </div>
      </header>

      <div className="login_bg wraper">
        <div className="bgOuter">
          <div className="leftBg text-center">
            <div className="alignBx">
              <div className="login-box">
                <div className={classes.form}>
                  <div className="container form paddingSp">
                    {/* <div className='form_Header'> */}
                    <div className="topParts">
                      <div className="row">
                        <div className="col-sm-8 login-logo text-left">
                          <img
                            src={loginlogo}
                            alt="test"
                            className="logo_Img"
                          />
                        </div>
                        <div className="col-sm-4 text-end">
                          <div className="dropdown choosDrops">
                            <button
                              className="btn btn-secondary dropdown-toggle"
                              type="button"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              Onboarding
                            </button>
                            <ul
                              className="dropdown-menu"
                              onClick={recrutingNav}
                            >
                              <li
                                className="dropdown-item"
                                style={{ cursor: "pointer" }}
                              >
                                {" "}
                                Recruiting
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>

                    <h4>Sign in to start onboarding with Avenu.</h4>
                    <h2>Welcome back! </h2>
                    {/* </div> */}
                    <div className="mt-0 wraper">
                      <div className="form-group mb-3">
                        {/* <label>Email </label> */}
                        <input
                          type="email"
                          className="form-control inputs-radus"
                          name="email"
                          placeholder="Enter email"
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </div>
                      <div className="form-group mb-3">
                        {/* <label>Password</label> */}
                        <div class="input-group-append">
                          <input
                            type={togglePassword ? "password" : "text"}
                            className="form-control"
                            name="password"
                            placeholder="Enter password"
                            onChange={(e) => setPassword(e.target.value)}
                          />
                          <button
                            type="button"
                            class="btn eye-bttn"
                            data-toggle="password"
                            onClick={() => setTogglePassword(!togglePassword)}
                          >
                            {togglePassword ? (
                              <img src={eye} alt="test" className="eye-img" />
                            ) : (
                              <img
                                src={eyeview}
                                alt="test"
                                className="eye-img"
                              />
                            )}
                          </button>
                        </div>
                      </div>
                      <div className="form-group text-end mb-0">
                        <a className="frgPasrd" href="#">
                          Forgot password?
                        </a>
                      </div>
                      <div className={classes.button}>
                        <button
                          type="submit"
                          className="btn btn-primary btn-block w-100 mt-4"
                          onClick={loginHandler}
                        >
                          Sign in
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="rightBg">
            <div className="alignBx">
              <div className="sliderWrapper">
                <div className="sliderImg text-center">
                  <img src={sliderImg} alt="test" className="sliderImg" />
                </div>
                <div className="sliderCont">
                  <h6 class="text-center slide_title">
                    Onboarding has never been easier.
                  </h6>
                  <p class="slide_des">
                    Are you tired of drowning in paperwork and the tedious tasks
                    of employee onboarding? Avenu has you covered with real-time
                    onboarding status updates and fully customizable templates.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* for showing toast */}
      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </Fragment>
  );
};

export default Login;
